export default __webpack_public_path__ + "static/overhead-b34840248c306ea0a591bf0fc5d3df5c.jpg";